import React from 'react';

import FeatureBlock from '../FeatureBlock/FeatureBlock';
import { GridReveal, GridItem } from '../UI/Grid/Grid';
import Section from '../UI/Section/Section';
import * as styles from './NavigationCards.module.scss';

const NavigationCards = ({ items, ...other }) => {
  return !items ? null : (
    <Section {...other}>
      <GridReveal>
        {items.map(({ title, description, image, link }, index) => {
          return (
            <GridItem md={items.length % 2 === 0 ? 6 : 4} key={index}>
              <FeatureBlock
                title={title}
                description={description}
                image={image}
                path={link.url}
              />
            </GridItem>
          );
        })}
      </GridReveal>
    </Section>
  );
};

export default NavigationCards;
